/* src/components/mandating-flow-info-card/mandating-flow-info-card.component.scss */
.mandating-info-card {
  width: 70%;
  margin: auto;
  box-shadow: var(--vwui--shadow--overlay), -2px 0 0 0 var(--vwui-color-info);
}
/*# sourceMappingURL=mandating-flow-info-card.component-XSWIG6DH.css.map */
